import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge the custom shadow tokens from tailwind.config.ts,
// otherwise `shadow-popover` is treated as a shadow color and never
// replaces `shadow-sm` & co.
const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			shadow: [
				{ shadow: ["card", "card-hover", "button", "popover"] },
			],
		},
	},
});

export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
